export const SUBMIT_COMMENT_REQUEST = 'SUBMIT_COMMENT_REQUEST';
export const SUBMIT_COMMENT_SUCCESS = 'SUBMIT_COMMENT_SUCCESS';
export const SUBMIT_COMMENT_FAILURE = 'SUBMIT_COMMENT_FAILURE';

export const submitCommentRequest = (ticket_id, comment) => ({
    type: SUBMIT_COMMENT_REQUEST,
    payload: {
        ticket_id,
        comment
    }
});

export const submitCommentSuccess = comment => ({
    type: SUBMIT_COMMENT_SUCCESS,
    payload: {
        comment
    }
});

export const submitCommentFailure = err => ({
    type: SUBMIT_COMMENT_FAILURE,
    error: err
});
